import {
  legalTeamSizeValues,
  levelOfExperienceValues,
  licensedLawyerValues,
} from './account-intake';
import { PositionsConst } from './position';

export const billingUnitValues = [5, 10, 15, 20, 25, 30, 35, 40] as const;

export const worksiteValues = {
  [PositionsConst.Worksites.Remote]: 'No, remote is fine',
  [PositionsConst.Worksites.OnsiteRemote]: 'Yes, periodically in our office',
  [PositionsConst.Worksites.Onsite]: 'Yes, full time in our office',
} as const;

export const selfServiceCountryCodes = {
  AU: 'Australia',
  CA: 'Canada',
  HK: 'Hong Kong',
  SG: 'Singapore',
  UK: 'United Kingdom',
  US: 'United States',
} as const;

/**
 * Dev Note: Great Britain (GB) is the country code return from the Google Maps component.
 * For example, if a user inputs "20 Dean's Yard, London SW1P 3PA, United Kingdom", then Great Britain (GB) will
 * be the resulting country and code returned. We don't want both GB and UK as selectable items, but want to allow both
 * to be sent to the backend as valid values.
 */
export const selfServiceCountryCodeExclusions = ['GB'];

export const instantMatchesAllowedCountryCode = 'US';

export const selfServiceAdditionalDetailsForTalentMaxLength = 400;

export const selfServiceIntakeDescriptionMaxLength = 1000;

export const levelOfExperienceAllowedValues = Object.keys(
  levelOfExperienceValues
) as Array<keyof typeof levelOfExperienceValues>;

export const licensedLawyerAllowedValues = Object.keys(
  licensedLawyerValues
) as Array<keyof typeof licensedLawyerValues>;

export const selfServiceAllowedCountryCodeValues = Object.keys(
  selfServiceCountryCodes
) as Array<keyof typeof selfServiceCountryCodes>;

export const worksiteAllowedValues = Object.keys(worksiteValues) as Array<
  keyof typeof worksiteValues
>;

export const legalTeamSizeAllowedValues = Object.values(legalTeamSizeValues);

export const ProjectNeedsDefaultRemoteLocation = {
  locationAddressComponents: {
    addresses: [
      {
        long_name: 'Default Remote Location',
        short_name: 'Default Remote Location',
        types: ['route', 'political'],
      },
      {
        long_name: 'Default Remote Location',
        short_name: 'Default Remote Location',
        types: ['locality', 'political'],
      },
      {
        long_name: 'Default Remote Location',
        short_name: 'NY',
        types: ['administrative_area_level_1', 'political'],
      },
      {
        long_name: 'United States',
        short_name: 'US',
        types: ['country', 'political'],
      },
    ],
  },
  locationLatitude: 40.7127753,
  locationLongitude: -74.0059728,
  locationName: 'Default Remote Location, USA',
  locationPlaceId: 'ChIJOwg_06VPwokRYv534QaPC8g',
};

export const hasLessThanThreeDecimalPlaces = (value: number): boolean => {
  const decimalPart = value.toString().split('.')[1];
  return !decimalPart || decimalPart.length <= 2;
};
